import { render, staticRenderFns } from "./RoomEmojis.vue?vue&type=template&id=b6026542&"
import script from "./RoomEmojis.vue?vue&type=script&lang=js&"
export * from "./RoomEmojis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports